import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const OrderSuccess = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container" style={{ 
      marginTop: window.innerWidth <= 960 ? '130px' : '20px',
    //   minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="order-success-container" style={{
        textAlign: 'center',
        maxWidth: '600px',
        padding: '40px 20px'
      }}>
        
        <h1 className="success-title" style={{
          fontSize: '2.5rem',
          color: '#ffffff',
          fontFamily: "'Hobilobi', 'Arial', sans-serif"
        }}>
          Order Confirmed!
        </h1>
        
        <p className="success-message" style={{
          fontSize: '1.2rem',
          color: '#cccccc',
          marginBottom: '15px',
          lineHeight: '1.6'
        }}>
          Thank you for your purchase. Your order has been successfully processed.
        </p>
        
        <p className="success-details" style={{
          fontSize: '1rem',
          color: '#999999',
          marginBottom: '40px'
        }}>
          Your order will be shipped to you as soon as possible.
        </p>

        <div className="success-actions" style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Link 
            to="/" 
            className="cta-button" 
            style={{
              padding: '12px 30px',
              backgroundColor: '#ff4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer',
              textDecoration: 'none',
              transition: 'background-color 0.3s',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#cc0000'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#ff4444'}
          >
            Return Home
          </Link>
          
          <Link 
            to="/store" 
            className="cta-button secondary" 
            style={{
              padding: '12px 30px',
              backgroundColor: 'transparent',
              color: '#ff4444',
              border: '2px solid #ff4444',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer',
              textDecoration: 'none',
              transition: 'all 0.3s',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#ff4444';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#ff4444';
            }}
          >
            Continue Shopping
          </Link>
        </div>

        <style>{`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default OrderSuccess;
